<template>
    <div class="module-accordion">
        <slot>
        </slot>
    </div>
</template>

<script>
    import $ from "jquery";
    import Accordion from "../libs/Accordion"

    export default {
        props: {},
        data() {
            return {
                uniqID: null
            };
        },
        methods: {},
        mounted() {
            this.uniqID = $(this.$el).find("[data-accordion]").attr("id")
            Accordion.init(this.uniqID)
        },
        destroyed() {
            Accordion.destroy()
        }
    };
</script>
